// Shows a sash in the top left with the branch name if the build querystring is defined.

import { toast } from '@app/components/ui/Toast/toast'
import { useShareLink } from '@app/hooks/useShareLink'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

// Module-level: survives route navigations but resets on page refresh
let buildBranchName: string | null = null

export const BuildSash = () => {
  const { copyShareLink } = useShareLink()
  const [searchParams] = useSearchParams()
  const [label, setLabel] = useState<string | null>(buildBranchName)

  useEffect(() => {
    const param = searchParams.get('build')
    if (param) {
      buildBranchName = param
      setLabel(param)
    }
  }, [searchParams])
  if (!label) return null

  const handleSashClick = async () => {
    try {
      await copyShareLink(`${window.location.pathname}?build=${label}`)
      toast({
        type: 'success',
        description: 'Share link copied to clipboard',
        position: 'top-right',
      })
    } catch {
      toast({
        type: 'error',
        description: 'Failed to copy link',
        position: 'top-right',
      })
    }
  }

  return (
    <div
      onClick={handleSashClick}
      style={{
        position: 'fixed',
        top: 28,
        left: -40,
        zIndex: 9999,
        width: 160,
        textAlign: 'center',
        transform: 'rotate(-45deg)',
        transformOrigin: 'center center',
        backgroundColor: '#f59e0b',
        color: '#000',
        fontSize: 8,
        fontWeight: 700,
        fontFamily: 'monospace',
        padding: '4px 0',
        cursor: 'pointer',
        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
        letterSpacing: '0.04em',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 160,
      }}
      title={label}
    >
      {label}
    </div>
  )
}
